import React from 'react'
import { AnimatePresence, motion, useReducedMotion } from 'motion/react'

export { AnimatePresence }

export const pageMotion = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.22,
      ease: 'easeOut',
      staggerChildren: 0.055,
      delayChildren: 0.04,
    },
  },
  exit: {
    opacity: 0,
    y: 8,
    transition: {
      duration: 0.16,
      ease: 'easeIn',
    },
  },
}

export const sectionMotion = {
  hidden: {
    opacity: 0,
    y: 18,
    filter: 'blur(2px)',
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: {
      duration: 0.28,
      ease: [0.22, 1, 0.36, 1],
    },
  },
}

export const metricMotion = {
  hidden: {
    opacity: 0,
    y: 14,
    scale: 0.98,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.24,
      ease: [0.22, 1, 0.36, 1],
    },
  },
}

export const tableRowMotion = {
  hidden: {
    opacity: 0,
    x: -8,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.2,
      ease: [0.22, 1, 0.36, 1],
    },
  },
}

export const AnimatedPage = ({ children }) => {
  return (
    <div style={{ width: '100%' }}>
      {children}
    </div>
  )
}

export const AnimatedSection = ({ children, variant = sectionMotion, style }) => {
  const reduceMotion = useReducedMotion()

  return (
    <motion.div
      initial={reduceMotion ? false : 'hidden'}
      animate={reduceMotion ? undefined : 'visible'}
      variants={reduceMotion ? undefined : variant}
      style={{ height: '100%', ...style }}
    >
      {children}
    </motion.div>
  )
}

export const AnimatedActionBar = ({ children }) => {
  const reduceMotion = useReducedMotion()

  return (
    <motion.div
      initial={reduceMotion ? false : 'hidden'}
      animate={reduceMotion ? undefined : 'visible'}
      variants={reduceMotion ? undefined : sectionMotion}
    >
      {children}
    </motion.div>
  )
}

export const AnimatedTableRow = ({ children, ...props }) => {
  const reduceMotion = useReducedMotion()

  return (
    <motion.tr
      initial={reduceMotion ? false : 'hidden'}
      animate={reduceMotion ? undefined : 'visible'}
      variants={reduceMotion ? undefined : tableRowMotion}
      {...props}
    >
      {children}
    </motion.tr>
  )
}

export const AnimatedValue = ({ value, children, className }) => {
  const reduceMotion = useReducedMotion()

  if (reduceMotion) {
    return <span className={className}>{children}</span>
  }

  return <span className={className}>{children}</span>
}
